import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';

@Injectable()
export class ResourcesDaoService {
  constructor(private http: HttpClient) {}

  list(url: string): Observable<any> {
    const params = new HttpParams().set('state', 'active').set('limit', '-1');
    const headers = new HttpHeaders().set('el-team', 'true');

    return this.http.get(url, {headers, params});
  }

  attach(url: string, data: any, nodeData?: any): Observable<any> {
    const params = new HttpParams().set('purposeId', nodeData.purposeId).set('type', nodeData.type);

    return this.http.put(url, data, {params});
  }

  create(resource: any, url: string): Observable<any> {
    const headers = new HttpHeaders().set('el-team', 'true');

    return this.http.post(url, resource, {headers});
  }

  remove(url: string, nodeData?: any): Observable<any> {
    const params = new HttpParams()
      .set('id', nodeData.resourceId)
      .set('purposeId', nodeData.purposeId)
      .set('type', nodeData.type);
    const headers = new HttpHeaders().set('el-team', 'true');

    return this.http.delete(url, {headers, params, responseType: 'text'});
  }
}
